import React from "react";
import styles from "./UploadFileDialog.module.scss";
import Dialog, {DialogProps} from "../Dialog/Dialog";
import UploadFileBodyUpload from "./UploadFileBodyUpload";
import UploadFileBodySuccess from "./UploadFileBodySuccess";
import UploadFileBodyError from "./UploadFileBodyError";

export interface UploadFileSelectDialogProps extends DialogProps {
  documentTitle: string;
  errorText?: string;
  fileName?: string;
  onFileSelectClick: React.MouseEventHandler<any>;
}

enum DIALOG_TYPE {UPLOAD, ERROR, SUCCESS}

class UploadFileDialog extends React.Component<UploadFileSelectDialogProps> {

  state = {
    type: DIALOG_TYPE.UPLOAD
  };

  componentWillReceiveProps(nextProps: any) {
    this.updateState(nextProps);
  }

  componentWillMount() {
    this.updateState(this.props);
  }

  render() {

    return (
      <Dialog
        id="ufdCargarDocDlg"
        icon={this.props.icon}
        title={"Cargar Documento"}
        confirmBtnText={"Cargar"}
        cancelBtnText={"Cancelar"}
        disableConfirm={this.props.disableConfirm}
        onCancel={this.props.onCancel}
        onConfirm={this.props.onConfirm}
        bodyCssClassName={styles.NoPadding}>

        <>

          <div className={styles.DocumentTitle}>{this.props.documentTitle}</div>

          {this.renderBody()}

          {this.state.type !== DIALOG_TYPE.SUCCESS &&
          <div className={styles.Instructions}>
            <span className={styles.Description}>Formatos: DOC, DOCX, JPEG, JPG, PDF, PNG, TIF, TIFF, XLS, XLSX.</span>
            <br/>
            <span className={styles.Description}>Solo se permite letras y n&uacute;meros en el nombre del archivo.</span>
            <br/>
            <span className={styles.Description}>Peso m&aacute;ximo: 8MB.</span>
          </div>
          }

        </>

      </Dialog>
    );
  }

  updateState = props => {
    if (props.errorText) {
      this.setState({type: DIALOG_TYPE.ERROR});
    } else if (props.fileName) {
      this.setState({type: DIALOG_TYPE.SUCCESS});
    }
  }

  renderBody = () => {
    switch (this.state.type) {
      case DIALOG_TYPE.UPLOAD:
        return (
          <UploadFileBodyUpload onFileSelectClick={this.props.onFileSelectClick}/>
        );
      case DIALOG_TYPE.SUCCESS:
        return (
          <UploadFileBodySuccess onReplaceFile={this.props.onFileSelectClick}
                                 fileName={this.props.fileName}/>
        );
      case DIALOG_TYPE.ERROR:
        return (
          <UploadFileBodyError onFileSelectClick={this.props.onFileSelectClick}
                               errorText={this.props.errorText}/>
        );
    }
  }

}

export default UploadFileDialog;
